import { StrategyStability } from "types/assessmentTypes";

export const clasterDatas = [
  {
    clasterName: "EnvironmentalSustainabilityAndResilience",
    clasterSubject: "ER",
    criterias: [29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    clasterName: "IndustryAttractiveness",
    clasterSubject: "IA",
    criterias: [],
  },
  {
    clasterName: "CompetitivePosition",
    clasterSubject: "CP",
    criterias: [
      4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
      24,
    ],
  },
];

export const IAWeights = {
  OIL_GAS_PETROCHEMICAL: 50.41,
  RENEWABLE_ENERGY: 56.48,
  PLASTIC_RUBBER: 43.56,
  WOOD_FURNITURE: 41.82,
  AUTOMOTIVE_TRANSPORT: 58.34,
  PHARMA_BIOTECH_MEDICAL: 70.33,
  ELECTRONICS_HARDWARE: 60.65,
  CHEMICAL_PETROCHEMICAL: 56.01,
  FOOD_AGRICULTURE: 48.64,
  METALS_METALLURGY: 43.7,
  PAPER_PRINTING: 33.57,
  INDUSTRIAL_MACHINERY: 58.14,
  NON_METALLIC_MINERALS: 42.61,
  TEXTILE_APPAREL: 53.08,
  SOFTWARE_IT: 76.55,
  SOFTWARE_IT_DATACENTER: 76.55,
  AEROSPACE_DEFENSE: 65.21,
  OTHER: 55.04,
};

export const StrategicRangeClassificationSRC = [
  { code: "L", title: "low", min: 0, max: 29 },
  { code: "T1", title: "Transition (L→M)", min: 30, max: 36, transition: true },
  { code: "M", title: "Medium", min: 37, max: 62 },
  { code: "T2", title: "Transition (M→H)", min: 63, max: 69, transition: true },
  { code: "H", title: "High", min: 70, max: 100 },
];

export const StrategicBoundaryEvaluationSBE = [
  {
    transitionCount: 0,
    ruleCount: 1,
    StrategicStability: StrategyStability.VeryHigh,
    DecisionStatus: "Stable",
  },
  {
    transitionCount: 1,
    ruleCount: 2,
    StrategicStability: StrategyStability.High,
    DecisionStatus: "NearBoundary",
  },
  {
    transitionCount: 2,
    ruleCount: 4,
    StrategicStability: StrategyStability.Medium,
    DecisionStatus: "Transitional",
  },
  {
    transitionCount: 3,
    ruleCount: 8,
    StrategicStability: StrategyStability.Low,
    DecisionStatus: "HighlyTransitional",
  },
];

export const StrategicDecisionEngineSDE = [
  {
    RULE: "R01",
    IA: "H",
    CP: "H",
    ER: "H",
    description: "conditionsIdealForGrowthAndInvestment",
    Confidence: "VeryHigh",
    StrategicDirection: "Growth",
  },
  {
    RULE: "R02",
    IA: "H",
    CP: "H",
    ER: "M",
    description: "growthWithManageableRisk",
    Confidence: "VeryHigh",
    StrategicDirection: "Growth",
  },
  {
    RULE: "R03",
    IA: "H",
    CP: "H",
    ER: "L",
    description: "environmentHindersAggressiveGrowth",
    Confidence: "High",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R04",
    IA: "H",
    CP: "M",
    ER: "H",
    description:
      "attractiveIndustryAndSuitableEnvironmentUpgradeCompetitionAlongsideGrowth",
    Confidence: "High",
    StrategicDirection: "Growth",
  },
  {
    RULE: "R05",
    IA: "H",
    CP: "M",
    ER: "M",
    description: "stabilizeCompetitiveAdvantageBeforeDevelopment",
    Confidence: "VeryHigh",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R06",
    IA: "H",
    CP: "M",
    ER: "L",
    description: "reviewBeforeInvestment",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R07",
    IA: "H",
    CP: "L",
    ER: "H",
    description: "marketIsSuitableButOrganizationIsNotReady",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R08",
    IA: "H",
    CP: "L",
    ER: "M",
    description: "firstStrengthenInternalCapabilities",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R09",
    IA: "H",
    CP: "L",
    ER: "L",
    description: "marketAttractivenessIsNotExploitable",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R10",
    IA: "M",
    CP: "H",
    ER: "H",
    description: "maintainPositionAndSelectiveGrowth",
    Confidence: "High",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R11",
    IA: "M",
    CP: "H",
    ER: "M",
    description: "maintainCompetitiveAdvantage",
    Confidence: "VeryHigh",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R12",
    IA: "M",
    CP: "H",
    ER: "L",
    description: "environmentalConstraintsNeedRevision",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R13",
    IA: "M",
    CP: "M",
    ER: "H",
    description: "balancedAndStableSituation",
    Confidence: "VeryHigh",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R14",
    IA: "M",
    CP: "M",
    ER: "M",
    description: "mostSuitableStrategyInBalancedConditions",
    Confidence: "VeryHigh",
    StrategicDirection: "Maintain",
  },
  {
    RULE: "R15",
    IA: "M",
    CP: "M",
    ER: "L",
    description: "reevaluateBeforeDevelopment",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R16",
    IA: "M",
    CP: "L",
    ER: "H",
    description: "strengthenCompetitiveCapabilities",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R17",
    IA: "M",
    CP: "L",
    ER: "M",
    description: "businessModelRevision",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R18",
    IA: "M",
    CP: "L",
    ER: "L",
    description: "furtherInvestmentIsNotJustified",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R19",
    IA: "L",
    CP: "H",
    ER: "H",
    description: "organizationIsStrongButIndustryIsNotAttractive",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R20",
    IA: "L",
    CP: "H",
    ER: "M",
    description: "exploreAlternativeMarketsAndOpportunities",
    Confidence: "High",
    StrategicDirection: "AnalyzeReview",
  },
  {
    RULE: "R21",
    IA: "L",
    CP: "H",
    ER: "L",
    description: "gradualExitIsRecommended",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R22",
    IA: "L",
    CP: "M",
    ER: "H",
    description: "industryAttractivenessIsLow",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R23",
    IA: "L",
    CP: "M",
    ER: "M",
    description: "focusOnMaintainingCashFlow",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R24",
    IA: "L",
    CP: "M",
    ER: "L",
    description: "noNewInvestmentRecommended",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R25",
    IA: "L",
    CP: "L",
    ER: "H",
    description: "weaknessInBothIndustryAndCompetition",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R26",
    IA: "L",
    CP: "L",
    ER: "M",
    description: "gradualExitIsLogical",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
  {
    RULE: "R27",
    IA: "L",
    CP: "L",
    ER: "L",
    description: "worstPossibleSituation",
    Confidence: "VeryHigh",
    StrategicDirection: "HarvestExit",
  },
];

export const finalStrategy = [
  {
    order: 1,
    T: [],
    DecisionScope: 1,
    StrategicStability: StrategyStability.VeryHigh,
  },
  {
    order: 2,
    T: ["IA"],
    DecisionScope: 2,
    StrategicStability: StrategyStability.High,
  },
  {
    order: 3,
    T: ["CP"],
    DecisionScope: 2,
    StrategicStability: StrategyStability.High,
  },
  {
    order: 4,
    T: ["ER"],
    DecisionScope: 2,
    StrategicStability: StrategyStability.High,
  },
  {
    order: 5,
    T: ["IA", "CP"],
    DecisionScope: 4,
    StrategicStability: StrategyStability.Medium,
  },
  {
    order: 6,
    T: ["IA", "ER"],
    DecisionScope: 4,
    StrategicStability: StrategyStability.Medium,
  },
  {
    order: 7,
    T: ["CP", "ER"],
    DecisionScope: 4,
    StrategicStability: StrategyStability.Medium,
  },
  {
    order: 8,
    T: ["IA", "CP", "ER"],
    DecisionScope: 8,
    StrategicStability: StrategyStability.Low,
  },
];

export const strategyModel = {
  Growth: 1,
  Maintain: 2,
  AnalyzeReview: 3,
  HarvestExit: 4,
};
